// FILE: src/app/_components/yandex-metrika-goals.tsx
// START_MODULE_CONTRACT:
// PURPOSE: Глобальный обработчик кликов по элементам с data-ym-goal для Яндекс.Метрики
// SCOPE: Слушает клики на document, находит [data-ym-goal], вызывает ym reachGoal
// INPUT: none (автоматический)
// OUTPUT: none (сайд-эффект: отправка целей в Метрику)
// KEYWORDS: TECH(YandexMetrika): goals; PATTERN(event-delegation): click-handler
// END_MODULE_CONTRACT

'use client';

import { useEffect } from 'react';

declare global {
  interface Window {
    ym?: (id: number, action: string, goal?: string) => void;
  }
}

export function YandexMetrikaGoals() {
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      const target = (e.target as HTMLElement).closest('[data-ym-goal]');
      if (target && typeof window.ym !== 'undefined') {
        const goal = target.getAttribute('data-ym-goal');
        if (goal) window.ym(107253138, 'reachGoal', goal);
      }
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  return null;
}
